export default __webpack_public_path__ + "static/media/ic-person-2.45e77aff.svg";